import React, { useCallback } from 'react';
import { translate } from '@td/shared_utils';
import { fieldTypes } from '../constants';
import { ChecklistItemForm, ChecklistItem, ChecklistItemsContainer, ChecklistFormContainer } from '../components';
import PropTypes from 'prop-types';

const DELETE_ITEM_CONFIRMATION = translate(null, 'care_team_tasks.form.fields.checklist', 'delete_confirmation');

const ChecklistFieldArray = ({ form: { values: { [fieldTypes.CHECKLIST]: items } }, replace, remove, push }) => {
  const confirmableCallbackFactory = useCallback(callback => () => {
    if (window.confirm(DELETE_ITEM_CONFIRMATION)) {
      callback();
    }
  }, []);

  return (
    <ChecklistFormContainer>
      {
        items.length ? (
          <ChecklistItemsContainer>
            {
              items.map((item, index) => (
                <ChecklistItem
                  key={index}
                  item={item}
                  onChange={val => replace(index, val)}
                  onDelete={confirmableCallbackFactory(() => remove(index))}
                />
              ))
            }
          </ChecklistItemsContainer>
        ) : null
      }
      <ChecklistItemForm
        onSubmit={text => push({ completed: false, text })}
      />
    </ChecklistFormContainer>
  );
};

ChecklistFieldArray.propTypes = {
  form: PropTypes.shape({ values: PropTypes.object }).isRequired,
  replace: PropTypes.func.isRequired,
  remove: PropTypes.func.isRequired,
  push: PropTypes.func.isRequired,
};

export default ChecklistFieldArray;
